import { Avatar } from '@mui/material'
import { DisplayNameDetails } from 'components/core/display-name-details'
import { C1Icon } from 'components/core/icons/C1Icon'
import { greyIconAvatarSx } from 'components/core/webhooks/WebhookDisplayName'
import { routes } from 'lib/routes'
import { Scale } from 'lucide-react'
import { Policy } from 'pbts/c1/api/policy/v1/policy'
import { FC } from 'react'

export type C1PolicyDisplayNameProps = {
    policy: Policy
    readOnly?: boolean
    drawerContent?: React.ReactElement
}

export const C1PolicyDisplayName: FC<C1PolicyDisplayNameProps> = ({
    policy,
    readOnly = false,
    drawerContent,
}) =>
    <DisplayNameDetails
        avatar={
            <Avatar sx={greyIconAvatarSx}>
                <C1Icon icon={Scale} size="sm" sx={{ color: 'info.main' }} />
            </Avatar>
        }
        displayName={policy.displayName}
        link={readOnly ? undefined : routes.settings.policies.detail(policy.id)}
        drawerContent={drawerContent}
        readOnly={readOnly}
        margin={false}
    />
